import {
  AutoFixHigh,
  BedroomParent,
  Business,
  DirectionsBoat,
  Favorite,
  Flight,
  Hotel,
  LocalActivity,
  Storefront,
  Tour,
} from '@mui/icons-material';

import {
  ROLE_ADMIN_USER,
  ROLE_CRUISE_COORDINATOR,
  ROLE_EMPLOYEE_USER,
  ROLE_EXPERIENCES_COORDINATOR,
  ROLE_HOTEL_COORDINATOR,
  ROLE_TOUR_COORDINATOR,
} from './roles';

export const PRODUCT_NAVIGATION_LINK_IDS = {
  BEDBANK: 'product-bedbank',
  CORPORATE_EVENTS: 'product-corporate-events',
  AI_TOOLS: 'product-ai-tools',
  CRUISES: 'product-cruises',
  EXPERIENCES: 'product-experiences',
  FLASH_AND_LPC: 'product-flash-and-lpc',
  FLIGHTS: 'product-flights',
  SHOP: 'product-shop',
  TOURS: 'product-tours',
  TRIP_PLANNER: 'product-trip-planner',
} as const;

export const PRODUCT_NAVIGATION_LINKS: Array<App.NavigationLink> = [
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.FLASH_AND_LPC,
    label: 'Flash & LPC',
    href: '/offers',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_HOTEL_COORDINATOR]),
    icon: Hotel,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.BEDBANK,
    label: 'Bedbank',
    href: '/bedbank/properties',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_HOTEL_COORDINATOR]),
    icon: BedroomParent,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.TOURS,
    label: 'Tours',
    href: '/tours',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_TOUR_COORDINATOR]),
    icon: Tour,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.FLIGHTS,
    label: 'Flights',
    href: '/flights',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
    icon: Flight,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.EXPERIENCES,
    label: 'Experiences',
    href: '/experiences',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EXPERIENCES_COORDINATOR]),
    icon: LocalActivity,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.CORPORATE_EVENTS,
    label: 'Corporate Events',
    href: '/corporate-events/events',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
    icon: Business,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.CRUISES,
    label: 'Cruises',
    href: '/cruises/offers',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_CRUISE_COORDINATOR]),
    icon: DirectionsBoat,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.SHOP,
    label: 'Shop',
    href: '/shop',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER]),
    icon: Storefront,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.TRIP_PLANNER,
    label: 'TripPlanner',
    href: '/trip-planner',
    requiredRoles: new Set([ROLE_ADMIN_USER, ROLE_EMPLOYEE_USER, ROLE_EXPERIENCES_COORDINATOR]),
    icon: Favorite,
  },
  {
    id: PRODUCT_NAVIGATION_LINK_IDS.AI_TOOLS,
    label: 'AI Tools',
    href: '/ai-tools',
    requiredRoles: new Set([
      ROLE_ADMIN_USER,
      ROLE_EMPLOYEE_USER,
      ROLE_HOTEL_COORDINATOR,
      ROLE_TOUR_COORDINATOR,
      ROLE_EXPERIENCES_COORDINATOR,
    ]),
    icon: AutoFixHigh,
  },
];
